import React, { PureComponent } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { graphql, compose } from "react-apollo";
import { capitalize } from "lodash";

import { Button } from "../Button/Button";
import EmojiForm from "./EmojiForm";
import Loading from "../Loading/Loading";
import Alert from "../Alert/Alert";
import { Input } from "../Form/TextInput/TextInput";
import { Container } from "../Grid/Container";

import { resetCode } from "../../actions";

import addEmojiMutationQuery from "../../queries/addEmojiMutation.gql";
import editEmojiMutationQuery from "../../queries/editEmojiMutation.gql";
import removeEmojiMutationQuery from "../../queries/removeEmojiMutation.gql";

import partyByCodeQuery from "../../queries/partyByCodeQuery.gql";
import editWebsiteMutation from "../../queries/editWebsiteMutation.gql";

const AdminFormContainer = styled.div``;

const LogoutLink = styled.a`
  color: black;
  font-size: 14px;
`;

const Section = styled.div`
  margin-bottom: 100px;
`;

const FormContainer = styled(Container)`
  background-color: #fafafa;
  margin-bottom: 50px;
  padding: 20px;
`;

class AdminForm extends PureComponent {
  state = {
    defaultEmoji: null,
    emojis: [],
    loading: false,
    valid: true,
    showErrors: false,
    website: ""
  };

  componentDidMount() {
    this.fillEmojis(this.props);
    this.setState({ website: this.props.website });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.emojis !== this.props.emojis ||
      nextProps.city !== this.props.city
    ) {
      this.fillEmojis(nextProps);
    }
    if (nextProps.website !== this.props.website) {
      this.setState({ website: nextProps.website });
    }
  }

  fillEmojis(props) {
    if (props && props.emojis && props.city) {
      let newEmojiState = [];
      for (let i = 0; i < props.city.amount; i++) {
        if (props.emojis[i]) {
          newEmojiState.push(props.emojis[i]);
        } else {
          newEmojiState.push({});
        }
        this.setState({ emojis: newEmojiState });
      }
    }
  }

  editEmoji(key, changedEmoji, isValid) {
    const { emojis } = this.state;
    const emojiCopy = emojis.slice(0);
    emojiCopy[key] = { ...changedEmoji, isValid };

    this.setState({
      emojis: emojiCopy
    });
  }

  async removeEmoji(id) {
    const { removeEmojiMutation, code } = this.props;

    this.setState({ loading: true });
    await removeEmojiMutation({
      variables: { code, id }
    });
    this.setState({ loading: false });

    return true;
  }

  async save() {
    const { emojis, website } = this.state;
    const {
      addEmojiMutation,
      editEmojiMutation,
      editWebsiteMutation,
      removeEmojiMutation,
      code
    } = this.props;
    this.setState({ loading: true, showErrors: false, valid: true });

    let notValid = emojis.filter(e => !e.isValid && e.dirty).length;
    if (notValid) {
      this.setState({ showErrors: true, valid: false, loading: false });
      window.scrollTo(0, 0);
      return;
    }

    if (website) {
      await editWebsiteMutation({
        variables: { code, website }
      });
    }

    for (let k in emojis) {
      const emojiObj = emojis[k];
      const { dirty, id, lat, lng, emoji, title, body, toRemove } = emojiObj;

      if (dirty) {
        if (id) {
          await editEmojiMutation({
            variables: {
              code,
              id,
              lat,
              lng,
              emoji,
              title,
              body
            }
          });
        } else {
          await addEmojiMutation({
            variables: {
              code,
              lat,
              lng,
              emoji,
              title,
              body
            }
          });
        }
      } else {
        // need to be clean to be able to to
        if (toRemove && id) {
          await removeEmojiMutation({
            variables: {
              id,
              code
            }
          });
        }
      }
    }

    this.setState({ loading: false });
    this.props.history.push("/overzicht");
  }

  render() {
    const { name, city, resetCode } = this.props;
    const { emojis, loading, valid, showErrors, website } = this.state;
    return loading ? (
      <Loading />
    ) : (
      <AdminFormContainer>
        <h1>
          Jouw partij: {name} - {capitalize(city.name)}{" "}
          <LogoutLink
            href="#"
            onClick={e => {
              e.preventDefault();
              resetCode();
            }}
          >
            (uitloggen)
          </LogoutLink>
        </h1>

        <Section>
          <h2>Jullie voorstellen</h2>

          <p>
            <em>
              Klik op de kaart om je emoji te plaatsen, of geef de specifieke
              locatie in het zoekveld in. Je verplaatst de emoji door opnieuw op
              de kaart te klikken.
            </em>
          </p>

          {!valid ? (
            <Alert>Er zijn één of meerdere fouten gevonden.</Alert>
          ) : null}

          {emojis.map((emoji, i) => (
            <div key={`emoji-${i}`}>
              <EmojiForm
                number={i + 1}
                emoji={emoji}
                onChange={(changedEmoji, isValid) =>
                  this.editEmoji(i, changedEmoji, isValid)
                }
                city={city}
                showErrors={showErrors}
                removeEmoji={id => this.removeEmoji(id)}
              />
            </div>
          ))}
        </Section>
        <Section>
          <h2>Jullie website</h2>
          <FormContainer>
            <p>
              Indien gewenst kan er worden doorgelinkt naar jullie website voor
              extra informatie. Geef daarvoor hieronder de URL in.
            </p>

            <Input
              label="Website"
              maxLength={100}
              name="website"
              error={showErrors && !valid["title"]}
              onChange={e => this.setState({ website: e.target.value })}
              value={website ? website : ""}
            />
          </FormContainer>

          <Button onClick={e => this.save()}>Opslaan</Button>
        </Section>
      </AdminFormContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    code: state.code
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetCode: () => {
      dispatch(resetCode());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  compose(
    graphql(addEmojiMutationQuery, {
      name: "addEmojiMutation",
      options: props => {
        return {
          refetchQueries: [
            {
              query: partyByCodeQuery,
              variables: {
                code: props.code
              }
            }
          ]
        };
      }
    }),

    graphql(editEmojiMutationQuery, {
      name: "editEmojiMutation",
      options: props => {
        return {
          refetchQueries: [
            {
              query: partyByCodeQuery,
              variables: {
                code: props.code
              }
            }
          ]
        };
      }
    }),
    graphql(removeEmojiMutationQuery, {
      name: "removeEmojiMutation",
      options: props => {
        return {
          refetchQueries: [
            {
              query: partyByCodeQuery,
              variables: {
                code: props.code
              }
            }
          ]
        };
      }
    }),
    graphql(editWebsiteMutation, {
      name: "editWebsiteMutation",
      options: props => {
        return {
          refetchQueries: [
            {
              query: partyByCodeQuery,
              variables: {
                code: props.code
              }
            }
          ]
        };
      }
    })
  )(AdminForm)
);



// WEBPACK FOOTER //
// ./src/components/AdminForm/AdminForm.js